import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Wrapper from '../../elements/wrapper';
import { media, TransitionMixin } from '../../helpers';
import { window } from 'browser-monads';

import Circles from '../../../images/about-banner-circles.inline.svg';
import ClimateIcon from '../../../images/icons/climate.inline.svg';
import RefugeesIcon from '../../../images/icons/refugees.inline.svg';
import SustainableIcon from '../../../images/icons/sustainable.inline.svg';
import CausesIcon from '../../../images/icons/causes.inline.svg';
import ManufacturingIcon from '../../../images/icons/manufacturing.inline.svg';

const aboutLinks = [
    {
        title: 'Fighting Climate' + `<br />` + 'Change',
        url: '/pages/fighting-climate-change',
        icon: <ClimateIcon />,
        class: 'climate',
    },
    {
        title: 'Helping' + `<br />` + 'Refugees',
        url: '/pages/helping-refugees',
        icon: <RefugeesIcon />,
        class: 'refugees',
    },
    {
        title: 'Sustainable ' + `<br />` + 'Products',
        url: '/pages/sustainable-products',
        icon: <SustainableIcon />,
        class: 'sustain',
    },
    {
        title: 'Our' + `<br />` + 'Causes',
        url: '/pages/our-causes',
        icon: <CausesIcon />,
        class: 'cause',
    },
    {
        title: 'Ethical' + `<br />` + 'Manufacturing',
        url: '/pages/ethical-manufacturing',
        icon: <ManufacturingIcon />,
        class: 'ethical',
    },
];

const AboutBannerContainer = styled.div`
    .banner-color-bg {
        min-height: 60vh;
        max-width: 100vw;
        position: relative;
        @media (max-width: 400px) {
            min-height: 65vh;
        }

        .banner-content-wrapper {
            text-align: center;
            padding: 10vh 0 0;
            ${media.small`padding: 18vh 0 0;`};
            ${media.large`padding: 20vh 0 0;`};
            h1 {
                color: #fff;
                font-size: 2.5rem;
                font-weight: 800;
                font-family: neue-kabel, sans-serif;
                ${media.large`font-size: 3.7rem;`};
            }

            p {
                color: #fff;
                max-width: 750px;
                margin: 0 auto;
                font-size: 1.2rem;
                line-height: 1.5;
            }
        }
        .svg-container {
            svg {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 100%;

                g {
                    mask: none;
                }
            }
        }
    }
    .banner-nav-container {
        padding-bottom: 40px;
        position: relative;
        top: -81.5px;
        margin-bottom: -81.5px;
        ${media.large`max-width: 90vw; top: -117.5px;margin-bottom: -117.5px; padding-bottom: 80px;`};
        ${media.laptop`max-width: 70vw;`};

        nav {
            ul {
                display: flex;
                flex-wrap: wrap;
                padding: 0;
                margin: 0;
                list-style: none;

                li {
                    flex: 0 0 50%;
                    justify-content: space-between;
                    margin-bottom: 30px;
                    ${media.medium`flex: 0 0 33.33%;`}
                    ${media.laptop`flex: 1; margin-right: 20px; margin-bottom: 0px;`}
                    &:last-child {
                        margin-right: 0px;
                    }
                    a {
                        background-color: #f2f0eb;
                        display: inline-block;
                        width: 100%;

                        text-align: center;
                        display: flex;
                        align-items: flex-end;
                        justify-content: center;
                        border-radius: 4px;
                        text-decoration: none;
                        max-width: 90%;
                        margin: 0 auto;
                        padding: 20px 10px;
                        min-height: 160px;
                        ${TransitionMixin('.25s')}
                        ${media.small`padding: 60px 10px;min-height: 230px;;`}
                        ${media.medium`padding: 60px 10px;min-height: 230px;;`}
                        ${media.laptop`max-width: 100%; padding: 60px 20px;min-height: 235px;`}

                        &:hover, &.active {
                            box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.25);
                            .inner-wrap {
                                .icon-container {
                                    svg {
                                        stroke: #fff;
                                        path {
                                            stroke: #fff;
                                        }
                                    }
                                }
                                h4 {
                                    font-style: normal;
                                    color: #fff;
                                }
                            }
                        }

                        &.climate {
                            &:hover,
                            &.active {
                                background-color: #3d3b0f;
                            }
                        }
                        &.refugees {
                            &:hover,
                            &.active {
                                background-color: #f74d33;
                            }
                        }
                        &.sustain {
                            &:hover,
                            &.active {
                                background-color: #1c7775;
                            }
                        }
                        &.cause {
                            &:hover,
                            &.active {
                                background-color: #ce7515;
                            }
                        }
                        &.ethical {
                            &:hover,
                            &.active {
                                background-color: #702716;
                            }
                        }

                        .inner-wrap {
                            .icon-container {
                                margin-bottom: 10px;
                                display: flex;
                                justify-content: center;
                                svg {
                                    stroke-width: 2px;
                                    stroke: #000;
                                    flex: 1;

                                    path {
                                        stroke: #000;
                                    }
                                }
                            }
                            h4 {
                                margin: 0;
                                color: #0f1212;
                                ${TransitionMixin('.25s')}
                            }
                        }
                    }
                }
            }
        }
    }
    .secondary-headline-wrapper {
        text-align: center;
        padding-bottom: 90px;
        ${media.medium`max-width: 750px;`}
        h3 {
            font-size: 2.2rem;
            line-height: 1.3;
            font-weight: 800;
            font-family: neue-kabel, sans-serif;
            margin: 0;
            ${media.medium`max-width: 750px; font-size: 2.5rem;line-height: 1.1;`};
        }
    }
`;

const AboutBanner = ({ color, headline, caption, secondaryHeadline }) => {
    function generateContent() {
        return { __html: caption };
    }
    return (
        <AboutBannerContainer>
            <Wrapper className="banner-color-bg" style={{ background: color }}>
                <Wrapper className="banner-content-wrapper">
                    <h1>{headline}</h1>
                    <div
                        className="content"
                        dangerouslySetInnerHTML={generateContent()}
                    ></div>
                </Wrapper>
                <div className="svg-container">
                    <Circles />
                </div>
            </Wrapper>
            <Wrapper className="banner-nav-container">
                <nav>
                    <ul>
                        {aboutLinks.map((link, index) => {
                            function generateTitle() {
                                return { __html: link.title };
                            }

                            const isSlugInURL = window.location.href.includes(
                                link.url
                            );
                            return (
                                <li key={index}>
                                    <Link
                                        className={
                                            isSlugInURL
                                                ? 'active ' + link.class
                                                : link.class
                                        }
                                        to={link.url}
                                    >
                                        <div className="inner-wrap">
                                            <div className="icon-container">
                                                {link.icon}
                                            </div>
                                            <h4
                                                dangerouslySetInnerHTML={generateTitle()}
                                            ></h4>
                                        </div>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </Wrapper>
            <Wrapper className="secondary-headline-wrapper">
                <h3 style={{ color: color }}>{secondaryHeadline}</h3>
            </Wrapper>
        </AboutBannerContainer>
    );
};

export default AboutBanner;
